import React from "react"
import fixture from "./fixture"
import Fixture from "./template/Fixture"
import { StyledFrameWrapper } from "./styles"

function LiveMonitorDeviceFrame(props) {
  const { data = fixture, onDeviceClick, onFrameClick } = props || {}
  const list = Array.isArray(data) ? data : [data]

  return (
    <StyledFrameWrapper>
      {list.map((item) => (
        <Fixture
          key={item.index || item.name}
          fixture={item}
          onDeviceClick={onDeviceClick}
          onFrameClick={onFrameClick}
        />
      ))}
    </StyledFrameWrapper>
  )
}

export { LiveMonitorDeviceFrame }
export default LiveMonitorDeviceFrame
